import { missing360DataBannerCyclesMessageAtom } from '@/atoms/dataLocker/general';
import { isPlayerGkAtom } from '@/atoms/dataLocker/player/game/table';
import { csvDownloadDataAtom } from '@/atoms/exporting';
import { filtersAtom } from '@/atoms/filters/filter';
import { lastAppliedFiltersAtom } from '@/atoms/filters/persistedFilters';
import { autoApplyFiltersAtom, selectedFilterSetIdAtom } from '@/atoms/filters/userFilters';
import { gameIdAtom } from '@/atoms/game/game';
import { metricsAtom } from '@/atoms/metric';
import { itemsPerPageAtom, pageAtom } from '@/atoms/pagination';
import { playerIdAtom } from '@/atoms/player/player';
import { tableColumnEntitiesAtom } from '@/atoms/queries/tableColumns';
import {
  radarTemplatePositionGroupAtom,
  renderedComparisonRadarDataAtom,
  renderedRadarDataAtom,
  selectedRadarTemplateIdAtom,
  selectedSummaryProfileIdAtom,
} from '@/atoms/radar';
import { sectionAtom } from '@/atoms/section';
import { isMobileFiltersPanelOpenAtom } from '@/atoms/sidebar';
import {
  clientOrderByAtom,
  clientOrderDirectionAtom,
  defaultTableColumnsAtom,
  serverOrderByAtom,
  serverOrderDirectionAtom,
  visibleTableColumnsAtom,
  tableIdAtom,
  metricValueModeAtom,
  showRankAtom,
} from '@/atoms/table';
import { teamIdAtom, teamTypeAtom } from '@/atoms/team/team';
import { userConfigActionAtom, userConfigIdAtom, userConfigNameAtom, userConfigTypeAtom } from '@/atoms/userConfigs';
import { selectedVisEventsAtom } from '@/atoms/vis/selection';
import {
  barChartOrientationAtom,
  isStartPlacementAtom,
  overwrittenVisualisationAtom,
  pitchCropAtom,
  pitchMarkerColouringModeAtom,
  pitchOrientationAtom,
  pitchOrientationReportWidgetAtom,
  pitchOrientationUserPreferenceAtom,
  showArrowsAtom,
  showLegendAtom,
} from '@/atoms/visualisation';

export const filterAtoms = [
  filtersAtom,
  selectedFilterSetIdAtom,
  autoApplyFiltersAtom,
  missing360DataBannerCyclesMessageAtom,
];

export const eventAtoms = [selectedVisEventsAtom];

export const visConfigAtoms = [
  showLegendAtom,
  showArrowsAtom,
  overwrittenVisualisationAtom,
  pitchCropAtom,
  pitchOrientationAtom,
  pitchOrientationReportWidgetAtom,
  pitchOrientationUserPreferenceAtom,
  isStartPlacementAtom,
  pitchMarkerColouringModeAtom,
  barChartOrientationAtom,
];

const panelOpenAtoms = [isMobileFiltersPanelOpenAtom];

export const radarAtoms = [
  selectedRadarTemplateIdAtom,
  selectedSummaryProfileIdAtom,
  renderedRadarDataAtom,
  renderedComparisonRadarDataAtom,
  metricsAtom,
  radarTemplatePositionGroupAtom,
];

export const layoutScopeAtoms = [
  ...filterAtoms,
  ...eventAtoms,
  ...visConfigAtoms,
  ...panelOpenAtoms,
  ...radarAtoms,
  playerIdAtom,
  teamIdAtom,
  teamTypeAtom,
  gameIdAtom,
  sectionAtom,
  lastAppliedFiltersAtom,
  metricValueModeAtom,
  showRankAtom,
];

// These atoms are also scoped at the DataLockerLayout level via layoutScopeAtoms, so all data locker
// pages share the same instance. This page-level scope ensures changes on one page don't leak to others.
export const dataLockerPageScopeAtoms = [tableColumnEntitiesAtom, metricValueModeAtom, showRankAtom];

export const tableAtoms = [
  pageAtom,
  itemsPerPageAtom,
  serverOrderByAtom,
  serverOrderDirectionAtom,
  clientOrderByAtom,
  clientOrderDirectionAtom,
  csvDownloadDataAtom,
  defaultTableColumnsAtom,
  visibleTableColumnsAtom,
  tableIdAtom,
  isPlayerGkAtom,
];

export const userConfigActionAtoms = [userConfigIdAtom, userConfigTypeAtom, userConfigActionAtom, userConfigNameAtom];
